export default "__VITE_PUBLIC_ASSET__1bd3aa76__"